import React from "react";

const Projectwmci = () => {
  return (
    <div>
      <p>Details </p>
    </div>
  );
};

export default Projectwmci;
